<head>
    <style>
        .my-pagination /deep/ .ngx-pagination .current {
            font-family: "Graphik SemiBold";
            font-weight: normal;
            font-style: normal;
            font-display: swap;
            color: #265d6e;
            background: transparent;
        }
    </style>
</head>
<div class="container-fluid">
    <div *ngIf="successAlert" id="success-alert" class="alert alert-success alert-dismissible fade show mt-3" role="alert">
        <strong id="videoTitle"></strong> <span id="message">{{successAlertMessage}} </span>
        <button (click)="closeSuccessAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div *ngIf="errorAlert" id="error-alert" class="alert alert-danger alert-dismissible fade show mt-3" role="alert">
        <span id="error-message">{{errorAlertMessage}}</span>
        <button (click)="closeErrorAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <nav class="navbar navbar-light sub-nav">
        <div class="left-nav">
            <a class="navbar-brand">
                <h5 class="Ws-subtitle">{{ constants.WINDOW_UPLOADED_TXT }}</h5>
            </a>
            <div class="btn-group">
                <button [disabled]="isdisabled || isLoading" (click)="onClickupdateStats()" type="button" class="button-generate">
                    <span *ngIf="isdisabled" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                    Update stats
                </button>
            </div>
            <!-- (click)="sort('createdAt')" -->
            <div class="btn-group">
                <button (click)="paginateLoad()" type="button" class="button-generate" [disabled]="startKey === undefined || isLoading">
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Load More
                </button>
            </div>
            <button [disabled]="isProcessing || !isMakeLive" (click)="onClickMakeLive()" class="button-generate">
                <span *ngIf="isProcessing" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
                Make Live
            </button>
        </div>
        <div class="right-nav">
            <a [routerLink]="['/admin/uploaded/1']">
                <p id="offline-button" class="live-buttons-active">Offline Videos</p>
            </a>
            <a [routerLink]="['/admin/uploaded']">
                <p id="live-button" class="live-buttons">
                    {{ constants.LIVE_VIDEO_TXT }}
                </p>
            </a>
            <span class="navbar-text justify-content-end">
                <input id="search" class="search" type="text" placeholder="search" (ngModelChange)="Search()"
                    [(ngModel)]="videoTitle" (ngModelChange)="Search()" />
            </span>
        </div>
    </nav>
    <div class="row uploaded-window" *ngIf="isLoading">
        <div *ngFor="let item of uploadSkeltonArray" class="col-3 uploaded-window-col">
            <img style="width: 100%" src="{{ item }}" alt="" />
        </div>
    </div>
    <div class="row uploaded-window" *ngIf="!isLoading">
        <div class="col-3 uploaded-window-col" *ngFor="
    let item of uploadedVideos
    | filter: videoTitle | paginate: { itemsPerPage: 250, currentPage: p }" id="{{ item.videoId }}">
            <div class="card uploaded-card">
                <div class="card-body uploaded-card-body row">
                    <div class="col uploaded-card-img-container" [attr.title]="item.videoType=='live' ? constants.ALREADY_IN_LIVE : null">
                        <input class="card-checkbox" type="checkbox" [checked]="item.isChecked" id="{{ item.videoId }}-offline"
                            (change)="onSelectTbleRow(item, $event)" [disabled]="item.videoType=='live'" [ngClass]="{'alreadyLive': item.videoType=='live'}"/>
                        <label for="{{ item.videoId }}-offline"><img class="uploaded-card-img" [ngClass]="{'alreadyLive': item.videoType=='live'}" src="{{ item.thumbnail }}"
                                alt="" /></label>
                    </div>
                    <div class="col uploaded-card-title-container">
                        <div class="upload-card-title">
                            <p class="uploaded-title" (click)="onClickVideoTitle(item, $event)"
                                id="{{ item.videoId }}title">
                                {{ item.cityLocation }}
                            </p>
                        </div>
                        <p class="upload-card-view">{{ item.stats }} views</p>
                        <!-- <p class="upload-card-bookamrk">123 bookmarks </p> -->
                        <p (click)="onClickName(item)" class="upload-card-author">
                            {{ item.author }}
                        </p>

                        <div class="deleteEdit-buttons">
                            <!-- Edit button -->
                            <button (click)="onClickEdit(item)" mat-button class="btn" [disabled]="!deletedisable">
                                <img src="{{ constants.EDIT_BUTTON }}" class="delete-img" />
                            </button>

                            <!-- Delete button -->
                            <button mat-button class="btn" (click)="openDialog(myDialog)" [disabled]="!deletedisable">
                                <img src="{{ constants.BASKET_IMG }}" class="delete-img" />
                            </button>
                            <span class="fs-10 liv-tag" *ngIf="item.videoType=='live'">L I V E</span>
                            <span class="fs-10 new-tag" *ngIf="item.isRecentlyApproved">N E W</span>
                        </div>
                    </div>
                    <!--Delete content -->

                    <ng-template #myDialog>
                        <mat-dialog-content class="mat-typography">
                            <p class="delete-title">Sure you want to delete?</p>
                        </mat-dialog-content>
                        <mat-dialog-actions align="center">
                            <button mat-button mat-dialog-close class="deleteButton" (click)="onClickDelete(item)">
                                Delete
                            </button>
                            <button mat-button [mat-dialog-close]="true" class="cancelButton" cdkFocusInitial>
                                Cancel
                            </button>
                        </mat-dialog-actions>
                    </ng-template>
                </div>
            </div>

        </div>
    </div>
    <nav class="navbar navbar-priamry footer loadMore  offline-footer">
        <pagination-controls class="my-pagination" (pageChange)="p = $event"></pagination-controls>
        <!-- <div class="btn-group" role="group" aria-label="Basic example">
    <button type="button" class="button-accept" (click)="clickPrevious()"
    [disabled]="isLoading || lastEvaluatedKeyArr.length === 1">prev</button>
    <button type="button" (click)="onvideoLoad()" class="button-accept"
    [disabled]="isLoading || startKey === undefined">Next</button>
    </div> -->
    </nav>
</div>